module.exports = __webpack_public_path__ + "static/media/left_sleeve.3b106cc0.png";